import React, { FC, ReactNode } from 'react';

export type TeaserGridContainerProps = {
  children?: ReactNode;
  sc?: number | string;
  mc?: number | string;
  lc?: number | string;
  xlc?: number | string;
  xxlc?: number | string;
  gap?: number | string;
  classes?: string;
};

const TeaserGridContainer: FC<TeaserGridContainerProps> = ({
  classes,
  sc = 2,
  mc = 4,
  lc = 5,
  xlc = 6,
  xxlc = 6,
  gap = 4,
  children,
}) => {
  return (
    <div
      className={`tw-grid tw-auto-rows-max small:tw-grid-cols-${sc} medium:tw-grid-cols-${mc} large:tw-grid-cols-${lc} xlarge:tw-grid-cols-${xlc} xxlarge-up:tw-grid-cols-${xxlc} tw-gap-${gap} ${
        !!classes && classes
      }`}
      data-testid="grid-results"
    >
      {children}
    </div>
  );
};

export default TeaserGridContainer;
